import ApiService from '@/core/services/api.service'

//action types
export const GET_CAJEROSASIGNADOS = "getCajerosAsignados";
export const GET_CAJEROASIGNADO = "getCajeroAsignado";
export const CREATE_CAJEROASIGNADO = "createCajeroAsignado";
export const UPDATE_CAJEROASIGNADO = "updateCajeroAsignado";
export const DELETE_CAJEROASIGNADO = "deleteCajeroAsignado";
export const DESACTIVAR_CAJEROASIGNADO = "desactivarCajeroAsignado"

//Mutadores
export const SET_CAJEROSASIGNADOS = "setCajerosAsignados"
export const SET_CAJEROASIGNADO = "setCajeroAsignado"
export const SET_ERROR = "setError"

const state = {
    error: null,
    cajeros: []
}

const actions = {
    [GET_CAJEROSASIGNADOS](context) {
        return new Promise((resolve) => {
            ApiService.setHeader();
            ApiService.get({ action: '/facturacioncomisionapi/api/AsignarCajero/v1/AsignarCajeros' }, "")
                .then(({ data }) => {
                    context.commit(SET_CAJEROSASIGNADOS, data);
                    resolve(data)
                })
                .catch(({ response }) => {
                    //console.log(("error: " + response);
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [GET_CAJEROASIGNADO](context, cajeroAsignado) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.get({ action: `/facturacioncomisionapi/api/AsignarCajero/v1/AsignarCajero/${cajeroAsignado.cajeroAsignadoId}` }, cajeroAsignado)
                .then(({ data }) => {
                    context.commit(SET_CAJEROASIGNADO, data)
                    resolve(data)
                })
                .catch(({ reponse }) => {
                    //console.log(("Hubo un error al obtener el cajero asignado. mensaje interno: " + response)
                    context.commit(SET_ERROR, "")
                })
        })
    },
    [CREATE_CAJEROASIGNADO](context, cajeroAsignado) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.post({ action: '/facturacioncomisionapi/api/AsignarCajero/v1/AsignarCajero/' }, cajeroAsignado)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, {
                        error: ["No se pudo ingresar el cajero"]
                    });
                    reject(response)
                });
        });
    },
    [UPDATE_CAJEROASIGNADO](contexto, cajeroAsignado) {
        return new Promise((resolve, reject) => {
            ApiService.put({ action: `/facturacioncomisionapi/api/AsignarCajero/v1/AsignarCajero/` }, cajeroAsignado)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [DELETE_CAJEROASIGNADO](context, cajeroAsignado) {
        return new Promise((resolve, reject) => {
            ApiService.setHeader();
            ApiService.delete({ action: `/facturacioncomisionapi/api/AsignarCajero/v1/AsignarCajero/${cajeroAsignado.cajeroAsignadoId}` }, cajeroAsignado)
                .then(({ data }) => {
                    resolve(data)
                })
                .catch(({ response }) => {
                    reject(response)
                })
        })
    },
    [DESACTIVAR_CAJEROASIGNADO](context, cajeroAsignado){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/AsignarCajero/v1/DesactivarCajeroAsignado'}, cajeroAsignado)
            .then(({ data }) => {
                resolve(data)
            })
            .catch(({ response }) => {
                reject(response)
            })
        })
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error
    },
    [SET_CAJEROSASIGNADOS](state, cajeros) {
        state.error = {};
        state.cajeros = cajeros
    }
}

export default {
    state,
    actions,
    mutations
}